package com.flowyride.app.di

import org.koin.core.context.startKoin
import org.koin.mp.KoinPlatform

/**
 * Starts DI once per process. Called by each platform entry point
 * (Android Application, iOS MainViewController, web main).
 */
fun initKoin() {
    if (KoinPlatform.getKoinOrNull() != null) return
    startKoin { modules(appModules) }
}
